import { Fragment } from "react";
import "./test_result_component.scss";

import LoaderPopUp from "../../../../../components/loader/loader";

//mobileDevice
import MobileLeftSideBarComponent from "../../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";
////////
import HeaderComponent from "../../../structure_components/desktop_screens/header_component/header_component";
import TestResultContentComponent from "./test_result_content_component/test_result_content_component";

//Redux
import { connect } from "react-redux";
import Footer_component from "../../../structure_components/desktop_screens/footer_component/Footer_component";

const TestResultComponent = (props) => {
  let { history, loader,userData, userPreference } = props;

  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Fragment>
      <div className="test_result_component_wrapper">
        <div className="test_result_component_inner_wrapper">
          {isMob() ? (
            <Fragment>
              <MobileLeftSideBarComponent />
              <MobileHeaderComponent
                userPreference={userPreference}
                userData={userData}
              />
              <MobileRightSideBarComponent history={history} />
              <TestResultContentComponent history={history} />
            </Fragment>
          ) : (
            <Fragment>
              <HeaderComponent />
              <TestResultContentComponent history={history} />
            </Fragment>
          )}
        </div>
      </div>
      <Footer_component />
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(TestResultComponent);
